import { Fragment } from 'react';
import { msg } from '@gonfalon/messages/msg';

import { CodeSpan } from '../../../CodeSpan';

import styles from './AnalysisUnitTokens.module.css';

/**
 * The selected analysis units rendered as inline code tokens — a read-only echo of
 * the analysis unit picker, for use inside the metric definition sentence.
 *
 * Joins with `or` before the last unit, since the metric is measured per whichever
 * unit the experiment randomizes by.
 */
export const AnalysisUnitTokens: React.FC<{ units: string[] }> = ({ units }) => {
  if (units.length === 0) {
    return <CodeSpan textValue={msg('metrics.metricDefinition.analysisUnitPlaceholder')} />;
  }

  return (
    <>
      {units.map((unit, i) => (
        <Fragment key={unit}>
          {i > 0 && i === units.length - 1 && <span>{msg('metrics.metricDefinition.unitsJoiner')}</span>}
          <span className={styles.token}>
            <CodeSpan textValue={unit} />
            {i < units.length - 2 && <span>,</span>}
          </span>
        </Fragment>
      ))}
    </>
  );
};
